<script setup lang="ts">
import { ref } from 'vue'
import { CircleInfoIcon } from 'Common/components/elements/icons/Icons'

const visible = ref(false)
let hoverTimeout: ReturnType<typeof setTimeout> | null = null

const showPopover = () => {
  hoverTimeout && clearTimeout(hoverTimeout)
  hoverTimeout = setTimeout(() => (visible.value = true), 200) // 200ms delay
}

const hidePopover = () => {
  hoverTimeout && clearTimeout(hoverTimeout)
  hoverTimeout = setTimeout(() => (visible.value = false), 200)
}
</script>

<template>
  <el-popover
    v-model:visible="visible"
    placement="bottom-end"
    :width="260"
    popper-style="
      box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px,
                  rgb(14 18 22 / 20%) 0px 10px 20px -15px;
      padding: 16px;
    "
  >
    <template #reference>
      <div
        class="inline-block cursor-pointer"
        @mouseenter="showPopover"
        @mouseleave="hidePopover"
        @click="visible = !visible"
      >
        <CircleInfoIcon class="text-white hover:text-gray-200 transition-colors" />
      </div>
    </template>

    <div class="flex flex-col gap-4 text-sm text-gray-700">
      <div class="font-semibold">Keyboard Shortcuts</div>

      <ul class="list-disc pl-5 space-y-2">
        <li>
          <strong>Hold Space</strong>, click + drag image to pan
          <span class="text-gray-900">(only works when zoomed in)</span>
        </li>

        <li><strong>Zoom to mouse cursor:</strong> scroll wheel, or two-finger swipe up/down</li>

        <li><strong>Drag mouse</strong> over multiple annotations to group edit</li>
      </ul>
    </div>
  </el-popover>
</template>
